import { render, staticRenderFns } from "./SwRoot.vue?vue&type=template&id=4f06022e"
import script from "./SwRoot.vue?vue&type=script&lang=js"
export * from "./SwRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports